import { getByType, answerViewTypes } from '../../../../conversational-search-logic/utils/utils';
import type { ConversationalSearchMessages, ConversationalSearchProductHierarchy, ConversationalSearchRefinements } from '../../../../conversational-search-types/conversational-search-types.type';

export const getCharacteristicsFollowup = (data: ConversationalSearchMessages['followups']): ConversationalSearchRefinements => {
    const getCharacteristics = (category: string) => getByType(data, category)?.characteristics || [];
    const multivalueCharacteristics = getCharacteristics(answerViewTypes.CharacteristicsMultiValue);
    const singleValueCharacteristics = getCharacteristics(answerViewTypes.CharacteristicsSingleValue);

    singleValueCharacteristics?.forEach((characteristic) => {
        if (characteristic.hasOwnProperty('value')) {
          characteristic.values = [characteristic.value];
          delete characteristic.value;
        }
    });

    return [...multivalueCharacteristics, ...singleValueCharacteristics];
};


export const extractProductHierarchySubLevels = (
  data: ConversationalSearchProductHierarchy['subLevels']
) => {
    const result = [];

    if (data && Object.keys(data).length > 0) {
      data.forEach(option => {
          if (option?.subLevels?.length) {
            result.push({
              name: option.title,
              values: option.subLevels.map(subLevel => subLevel.title)
            });
          }
      });
    }

    return result;
};

